/**
 * Application-wide constants
 */

export const RESPONSIVE_BREAKPOINT = '940px';

/**
 * Allowed file extensions for document uploads
 * Includes: PDF, Word, Excel, PowerPoint, Text, and Visio files
 */
export const ALLOWED_FILE_EXTENSIONS = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.vsdx,.vsdm,.vssx,.vstm,.vstx,.vsd,.vdx';

/**
 * Allowed file extensions for flowcharts and test sheets (subset without presentation files)
 */
export const ALLOWED_DOCUMENT_EXTENSIONS = '.pdf,.doc,.docx,.xls,.xlsx,.vsdx,.vsdm,.vssx,.vstm,.vstx,.vsd,.vdx';